import React from "react";
import "./ScrollUp.css";

import { FiArrowUp } from "react-icons/fi";

const ScrollUp = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

 

  return (
    <div>
      <button
        onClick={scrollToTop}
        className="scrollup"
        aria-label="Voltar ao topo da página" 
      >
        <FiArrowUp className="scrollup__icon" />
      </button>
    </div>
  );
};

export default ScrollUp;
